import RichLocale from './RichLocale';
export default RichLocale;
